import React from 'react'

const AboutUs = () => {
    return (
        <div id="nous" className="min-h-screen h-full " >
            <br />
            <h1 className='text-3xl font-semibold pt-10 mb-4 py-3 pb-4' >Sour nous</h1>
            <p className=' mx-2 p-4 lg:mx-40 ' >Bonjour chez <b>Nom du Garage</b>, au <b> location : Adress</b></p>
            <p className='my-4'>Notre Horaire :</p>
            <p>Lundie :8-21</p>
            <p>Mardie :8-21</p>
            <p>Mercredie :8-21</p>
            <p>Jeudie :8-21</p>
            <p>Samedie :8-21</p>
            <p>Dimenche :8-21</p>
            <p className="py-2"> <b> Notre localisation :</b></p>

            <br />
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3324.1328472067116!2d-7.70900968531396!3d33.575899850129936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7d4a33900f835%3A0xb540923b5bdf10fb!2sMorocco%20Mall!5e0!3m2!1sen!2sma!4v1659896364702!5m2!1sen!2sma" className="w-full" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            
        </div>
    )
}

export default AboutUs
